export const languageStringsContact = {
  title: "Dane kontaktowe",
  basic: {
    title: "Podstawowe informacje",
    accountType: "Typ konta",
    personal: "Osobiste",
    business: "Biznesowe",
    name: "Imię",
    surname: "Nazwisko",
    phone: "Numer telefonu",
    dic: "NIP",
    ico: "REGON",
    companyName: "Nazwa firmy",
  },
  address: {
    title: "Adres",
    street: "Ulica i nr",
    city: "Miasto",
    zip: "Kod pocztowy",
    country: "Kraj",
    state: "Stan",
    czechRepublic: "Republika Czeska",
    slovakia: "Słowacja",
    hungary: "Węgry",
    polish: "Polska",
  },
};
